<app-header
  (updateExpensiveEndgameCostEvent)="onUpdateEndgameCost($event)"
  (updateLocaleEvent)="onUpdateLocale($event)"
  (updateResourceCostMultiplierEvent)="onUpdateResourceCostMultiplier($event)"
></app-header>

<div class="container-fluid top-padding bottom-margin">
  <app-crafting-parent></app-crafting-parent>
</div>

<app-footer></app-footer>
